import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Tooltip,
  Collapse,
  Grid,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import EditIcon from '@material-ui/icons/Edit'
import { DetailPanel } from 'components/DescricoesVestigiosExame/DescricoesTecnicasVestigio/DetailPanel'
import { getLabelTipoVestigioEspecifico, getTipoVestigioLabel } from 'helpers/labels'
import { useStyles } from '../ExameEficienciaBalistica.styles'

const getAnaliseRevelacaoDeExame = (analises, idExameRealizado) => {
  let result = null
  if (analises) {
    analises.forEach((analise) => {
      if (analise.id_exame_realizado === Number(idExameRealizado)) {
        result = analise
      }
    })
  }
  return result
}

export const LinhaTabelaRevelacaoFisicoQuimico = (props) => {
  const {
    descricaoVestigioBalistico,
    handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico,
    idExameRealizado,
  } = props

  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [openDetail, setOpenDetail] = useState(false)

  if (isMobile) {
    return (
      <div className={classes.cardMobile}>
        <div className={classes.cabecalhoCard}>
          <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
            #{descricaoVestigioBalistico.descTec?.id} -{' '}
            {getTipoVestigioLabel(descricaoVestigioBalistico.descTec?.tipoVestigioGenerico)?.toUpperCase()}
          </Typography>
          <div className={classes.acoesCard}>
            <Tooltip title="Realizar análise de revelação">
              <IconButton
                size="small"
                onClick={() =>
                  handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico(descricaoVestigioBalistico.id)
                }
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton size="small" onClick={() => setOpenDetail(!openDetail)}>
              {openDetail ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
            </IconButton>
          </div>
        </div>
        <div className={classes.conteudoCard}>
          <span className={classes.labelCard}>Especificação: </span>
          {getLabelTipoVestigioEspecifico(descricaoVestigioBalistico.descTec?.tipoVestigioEspecifico)?.toUpperCase()}
        </div>
        <div className={classes.conteudoCard}>
          <span className={classes.labelCard}>Resultado: </span>
          {descricaoVestigioBalistico.anaRevFisQuims?.length ? (
            descricaoVestigioBalistico.anaRevFisQuims[0]?.resultado
          ) : (
            'NÃO REALIZADA'
          )}
        </div>

        {openDetail && (
          <Collapse in={openDetail} timeout="auto" unmountOnExit>
            <div style={{ marginTop: theme.spacing(1) }}>
              <DetailPanel
                idDescricaoTecnica={descricaoVestigioBalistico.descTec?.id}
                tipoVestigio={descricaoVestigioBalistico.descTec?.tipoVestigioGenerico}
              >
                <Grid item className={classes.divTitulo} sm={12} xs={12} md={12}>
                  <Typography variant="subtitle2">
                    <b>ANÁLISE DE REVELAÇÃO FÍSICO-QUÍMICO</b>
                  </Typography>
                </Grid>
                {descricaoVestigioBalistico.anaRevFisQuims?.length ? (
                  <Grid item container md={12} sm={12} xs={12} spacing={1} className={classes.grupoEspelho}>
                    <Grid item md={12} sm={12} xs={12}>
                      <Typography className={classes.dadoEspelho}>
                        <b>RESULTADO COMPLETO</b>
                      </Typography>
                      <Typography variant="body2">
                        {getAnaliseRevelacaoDeExame(descricaoVestigioBalistico.anaRevFisQuims, idExameRealizado)
                          ?.resultado?.toUpperCase() || 'NÃO REALIZADO'}
                      </Typography>
                    </Grid>
                    {descricaoVestigioBalistico.anaRevFisQuims[0].resultado?.toUpperCase() === 'POSITIVO' && (
                      <Grid item md={12} sm={12} xs={12} style={{ marginTop: theme.spacing(1) }}>
                        <Typography className={classes.dadoEspelho}>
                          <b>NÚMERO DE SÉRIE</b>
                        </Typography>
                        <Typography variant="body2">
                          {descricaoVestigioBalistico.anaRevFisQuims[0].numeroSerie}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
                    <Grid item md={12} sm={12} xs={12}>
                      <Typography variant="body2">Não foi realizado exame químico-metalográfico neste item</Typography>
                    </Grid>
                  </Grid>
                )}
              </DetailPanel>
            </div>
          </Collapse>
        )}
      </div>
    )
  }

  // Desktop Table Row
  return (
    <>
      <TableRow className={classes.tableRow} onClick={() => setOpenDetail(!openDetail)}>
        <TableCell style={{ width: '5%' }}>
          <IconButton aria-label="expand row" size="small">
            {openDetail ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ width: '30%' }}>
          <Typography style={{ fontSize: '13px' }}>
            #{descricaoVestigioBalistico.descTec?.id} -{' '}
            {getTipoVestigioLabel(descricaoVestigioBalistico.descTec?.tipoVestigioGenerico)?.toUpperCase()} -{' '}
            {getLabelTipoVestigioEspecifico(descricaoVestigioBalistico.descTec?.tipoVestigioEspecifico)?.toUpperCase()}
          </Typography>
        </TableCell>

        <TableCell style={{ width: '45%' }}>
          {descricaoVestigioBalistico.anaRevFisQuims?.length ? (
            <Typography>{descricaoVestigioBalistico.anaRevFisQuims[0]?.resultado}</Typography>
          ) : (
            <Typography>NÃO REALIZADA</Typography>
          )}
        </TableCell>
        <TableCell style={{ width: '20%' }} onClick={(e) => e.stopPropagation()}>
          <Tooltip title="Realizar análise de revelação">
            <IconButton
              size="small"
              onClick={() =>
                handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico(descricaoVestigioBalistico.id)
              }
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>

      {openDetail && (
        <TableRow>
          <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={openDetail} timeout="auto" unmountOnExit>
              <DetailPanel
                idDescricaoTecnica={descricaoVestigioBalistico.descTec?.id}
                tipoVestigio={descricaoVestigioBalistico.descTec?.tipoVestigioGenerico}
              >
                <Grid item className={classes.divTitulo} sm={12} xs={12} md={12}>
                  <Typography variant="subtitle2">
                    <b>ANÁLISE DE REVELAÇÃO FÍSICO-QUÍMICO</b>
                  </Typography>
                </Grid>

                {descricaoVestigioBalistico.anaRevFisQuims?.length ? (
                  <Grid item container md={12} sm={12} xs={12} spacing={1} className={classes.grupoEspelho}>
                    <Grid item md={6} sm={6} xs={12}>
                      <Typography className={classes.dadoEspelho}>
                        <b>RESULTADO</b>
                      </Typography>
                      <Typography variant="body2">
                        {getAnaliseRevelacaoDeExame(descricaoVestigioBalistico.anaRevFisQuims, idExameRealizado)
                          ?.resultado?.toUpperCase() || 'NÃO REALIZADO'}
                      </Typography>
                    </Grid>

                    {descricaoVestigioBalistico.anaRevFisQuims[0].resultado?.toUpperCase() === 'POSITIVO' && (
                      <Grid item md={6} sm={6} xs={12}>
                        <Typography className={classes.dadoEspelho}>
                          <b>NÚMERO DE SÉRIE</b>
                        </Typography>
                        <Typography variant="body2">
                          {descricaoVestigioBalistico.anaRevFisQuims[0].numeroSerie}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
                    <Grid item md={6} sm={6} xs={12}>
                      <Typography variant="body2">Não foi realizado exame químico-metalográfico neste item</Typography>
                    </Grid>
                  </Grid>
                )}
              </DetailPanel>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

LinhaTabelaRevelacaoFisicoQuimico.propTypes = {
  descricaoVestigioBalistico: PropTypes.object.isRequired,
  handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico: PropTypes.func.isRequired,
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
